/**
 * Build invited_profiles for work panel invite API requests.
 *
 * Non-registered invitees must remain in the payload even when chat access is
 * off so the backend can grant resource role without conversation participation.
 *
 * @param {Array<object>} userProfilesWithRoles
 * @returns {{ invitedProfiles: Array<object>, tempIds: Array<number|string> }}
 */
export function buildWorkPanelInviteProfilesPayload(userProfilesWithRoles = []) {
    const tempIds = [];

    const invitedProfiles = userProfilesWithRoles.map((userProfile) => {
        const copy = { ...userProfile };

        if (copy.non_registered) {
            tempIds.push(copy.id);
            copy.id = 0;
        }

        delete copy.access_level;
        delete copy.is_organization_user;

        return copy;
    });

    return {
        invitedProfiles,
        tempIds,
    };
}

/**
 * @param {Array<number|string>} profileIds
 * @param {Array<number|string>} tempIds
 */
export function filterWorkPanelInviteProfileIds(profileIds = [], tempIds = []) {
    return profileIds.filter(
        (profileId) => profileId && !tempIds.includes(profileId),
    );
}
